import styled from 'styled-components';
import { colours, Dialog } from '@cambridgeassessment/cambridge-ui';

interface StyleProps {
  disabled?: boolean;
}

export const StyledFileTypesComponentContainer = styled.div`
  padding-top: 16px;
`;

export const StyledFileTypesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  grid-row-gap: 24px;
  margin-top: 16px;
`;

export const StyledPlagiarismContainer = styled.div`
  display: flex;
  padding-top: 14px;
`;

export const StyledPlagiarismDescription = styled.div`
  width: 204px;
  height: 38px;
  font-family: SourceSansPro;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
`;

export const StyledFileTypeContainer = styled.div`
  display: grid;
  grid-template-columns: 42px 300px;
  align-items: flex-start;
`;

export const StyledWordDocumentContainer = styled.div`
  display: flex;
`;

export const StyledFileTypes = styled(Dialog)`
  text-transform: uppercase;
  color: ${colours.abbey};
  font-weight: 600;
  opacity: 0.8;
`;

export const StyledFileTypeNameSubtext = styled(StyledFileTypes)`
  margin-left: 5px;
`;

export const StyledFileTypeDescription = styled.div`
  color: ${colours.abbey};
  width: 100%;
`;

export const StyledFileNameContainer = styled.div`
  padding-top: 10px;
`;

export const StyledFileTypesBlock = styled.div<StyleProps>`
  font-family: SourceSansPro;
  grid-column-start: 2;
  opacity: ${(props): number => (props.disabled ? 0.6 : 1)};
  padding: 0 0 32px;
`;
